import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'

export const projectDetailTooltipByType = {
  businessId: <TextTooltip text="Jedinečné číslo investičnej príležitosti" />,
  loanType: <TextTooltip text="Typ poskytnutého úveru dlžníkovi" />,
  creditLine: (
    <TextTooltip text="Toto je maximálna suma úveru, ktorá bola schválená pre tento konkrétny typ zaistenia. Investori budú mať možnosť využiť výšku úverového rámca pre svoje investície" />
  ),
  stageSize: (
    <TextTooltip text="Celkový úverový rámec je rozdelený do viacerých tranží. Investori majú možnosť postupne investovať do jednotlivých tranží až do vyčerpania schválenej výšky úveru" />
  ),
  remainingInvestmentAmount: (
    <TextTooltip text="Uvádza sa suma, ktorá ešte ostáva na investície do dosiahnutia plného naplnenia úverového rámca, teda celkovej schválenej sumy úveru" />
  ),
  minimumInvestment: (
    <TextTooltip text="Minimálna výška investície, ktorú môže investor investovať" />
  ),

  collateral: (
    <TextTooltip text="Kolaterál predstavuje majetok alebo hodnotu, ktorú dlžník poskytuje ako záruku pre úver. Toto zabezpečenie chráni investora a môže byť uplatnené v prípade, že dlžník nesplní svoje záväzky podľa úverovej zmluvy" />
  ),
  otherCollaterals: (
    <TextTooltip text="Okrem kolaterálu môžu byť súčasťou vzťahu medzi investorom a dlžníkom aj ďalšie formy zabezpečenia, ktoré poskytujú dodatočnú ochranu pre investície" />
  ),
  complexAnalysis: (
    <TextTooltip text="Tento proces detailne skúma až 66 parametrov úveru poskytnutého dlžníkovi. Výsledky týchto vyhodnotení nám umožňujú správne určiť LTV (Loan to Value), tzn. Správne nastaviť optimálnu výšku úveru (investície) vzhľadom na hodnotu zabezpečenia (kolaterálu)" />
  ),
  ltlPercentage: (
    <TextTooltip text="Namiesto tradičného pomeru LTV (Loan to Value) sme zaviedli LTL (Loan to Liquidity). LTL predstavuje pomer medzi tržnou hodnotou zaisteného majetku a výškou poskytnutého úveru. Tento pomer pomáha lepšie hodnotiť likviditu majetku v prípade potreby jeho predaja" />
  ),
  creditorPosition: (
    <TextTooltip text="Investor v úlohe veriteľa môže zaujať rôzne postavenia v porovnaní s ostatnými veriteľmi. Najvýhodnejšou pozíciou je seniorná pozícia, kde veriteľ má právo na prednostné vyplatenie svojich pohľadávok. Po seniorných veriteľoch, ktorými sú často banky, nasleduje juniorná pozícia, ktorá sa vypláca až druhá v poradí. Výhodou juniorného veriteľa je obvykle vyšší výnos ako má seniorný veriteľ" />
  ),
  collateralAgent: (
    <TextTooltip text="Poskytnutý úver má svojho zabezpečovacieho agenta a zároveň spoluinvestora, ktorý chráni investície investorov vykonateľným záložným právom na majetok dlžníka. Taktiež pomáha pri riešení v prípade omeškania platieb od dlžníka" />
  ),
  coInvestment: (
    <TextTooltip text="Invest in Slovakia prostredníctvom samostatnej entity investuje spoločne s ďalšími investormi. Zároveň pôsobí aj ako zabezpečovací agent, ktorý chráni investície investorov záložným právom na majetok dlžníka, čím zaisťuje bezpečnosť investovaných prostriedkov" />
  ),
  latePaymentFeePercentage: (
    <TextTooltip text="Ak dlžník nespláca svoj záväzok, dlžná suma sa úročí dodatočným úrokom podľa dohody v zmluve o sprostredkovaní investície. Aktuálne úrokové sadzby Európskej centrálnej banky (ECB) si môžete pozrieť tu" />
  ),

  propertyType: (
    <TextTooltip text="Určuje druh nehnuteľnosti, ktorý slúži ako zabezpečenie úveru" />
  ),
  cadastralArea: (
    <TextTooltip text="Označuje presnú lokalitu alebo oblasť, v ktorej sa nachádza nehnuteľnosť slúžiaca ako zaistenie úveru" />
  ),

  owners: <TextTooltip text="Vlastník zaistenej nehnuteľnosti" />,
  encumbrances: (
    <TextTooltip text="Tento údaj informuje o tom, či na zaistenej nehnuteľnosti existujú aj iné ťarchy alebo záložné práva okrem záložného práva Trezor agent s.r.o.. To môže zahŕňať existujúce hypotéky alebo iné právne záväzky, ktoré ovplyvňujú práva a prioritné postavenie investorov" />
  ),
  rentalContracts: (
    <TextTooltip text="Tento údaj poskytuje informácie o existujúcich nájomných zmluvách týkajúcich sa zaistenej nehnuteľnosti" />
  ),
  otherLiabilities: (
    <TextTooltip text="Tento údaj informuje o ďalších existujúcich nesplatených záväzkoch spojených s nehnuteľnosťou, ako sú údržbové povinnosti, poistenie, dane alebo iné finančné alebo právne povinnosti, ktoré môžu ovplyvniť likviditu nehnuteľnosti" />
  ),
  expertValueEstimate: (
    <TextTooltip text="Znalecká hodnota predstavuje odborný odhad ceny nehnuteľnosti, ktorý zvyčajne vypracuje licencovaný znalec a môže zahŕňať rôzne faktory ako stav nehnuteľnosti, umiestnenie a konkurenčné porovnania" />
  ),
  marketValue: (
    <TextTooltip text="Trhová hodnota je odhadovaná suma, za ktorú by nehnuteľnosť mohla byť predaná na otvorenom trhu v aktuálnych ekonomických a trhových podmienkach" />
  ),

  latePayments: (
    <TextTooltip text="Tento údaj poskytuje informácie o existujúcich omeškaniach v platení dlžníka na platforme Invest in Slovakia." />
  ),
  companyName: (
    <TextTooltip text="Tento údaj uvádza meno právnickej osoby, samostatne zárobkovo činnej osoby alebo fyzickej osoby, ktorá figuruje ako dlžník." />
  ),
}
